module.exports = __webpack_public_path__ + "static/img/1242_phase_function_Paper_Points.9c41597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1242_phase_function_Paper_Points.png
// module id = xqAm
// module chunks = 0